import React, { Component } from 'react';
import ThreeOptions from './ThreeOptions';
import FourOptions from './FourOptions';

class Step7 extends Component {
    render() {
        return (

            <div className="card card-body">

                <div className="form-group">
                    <div className="row">
                        <div className='col-sm-12 h5'>COMMUNICATION TEST</div>

                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <ThreeOptions
                                name="commCA38A"
                                label="CA38A Jack Located within 1M of the Signal Transmitter"
                            />
                        </div>
                        <div className="col-sm-12 ">
                            <FourOptions
                                name="commPassive1801st"
                                label="On Passive System, did the failure of the 1st communication path report on the 2nd path within 180s"
                            />
                        </div>
                        <div className="col-sm-12 ">
                            <FourOptions
                                name="commPassive1802nd"
                                label="On Passive System, did the failure of the 2nd communication path report on the 1st path within 180s"
                            />
                        </div>
                        <div className="col-sm-12 ">
                            <FourOptions
                                name="commActiveFailure"
                                label="On Active Systems, did the failure of the communication path generate a failure at the FSRC within 180s"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Step7;



// WEBPACK FOOTER //
// ./src/components/Step7.js